import React from 'react'
import ProjectAutofillInfoNote from './ProjectAutofillInfoNote.tsx'
import { rubroDocumentationSectionIntroText } from './projectAutofillCard/projectAutofillCardUtils.ts'

type Props = {
  sourceFileLabel?: string | null
}

const RubroDocumentationSectionIntro: React.FC<Props> = ({ sourceFileLabel }) => (
  <ProjectAutofillInfoNote variant="rubroInfo">
    {rubroDocumentationSectionIntroText(sourceFileLabel)}
  </ProjectAutofillInfoNote>
)

export default RubroDocumentationSectionIntro
